import { gql } from '__generated__'

export const GetRecruitersByName = gql(/* GraphQL */ `
    query GetRecruitersByName($limit: Float, $page: Float, $name: String) {
        recruiters(limit: $limit, page: $page, name: $name) {
            data {
                id
                userId
                user {
                    firstName
                    lastName
                    nickname
                }
            }
            pageInfo {
                itemTotal
                pageNumber
                pageTotal
            }
        }
    }
`)

export const GetRecruitersByIds = gql(/* GraphQL */ `
    query GetRecruitersByIds($ids: [ID!]!) {
        recruitersById(ids: $ids) {
            id
            userId
            user {
                firstName
                lastName
                nickname
            }
        }
    }
`)

export const GetRecruitersByUserIds = gql(/* GraphQL */ `
    query GetRecruitersByUserIds($ids: [ID!]!) {
        recruitersByUserId(ids: $ids) {
            id
            userId
            user {
                firstName
                lastName
                nickname
            }
        }
    }
`)
